import script from "./StickersToolsTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./StickersToolsTabs.vue?vue&type=script&setup=true&lang=js"

import "./StickersToolsTabs.vue?vue&type=style&index=0&id=59d4d3bf&lang=scss"

const __exports__ = script;

export default __exports__